const TIPOS_SOPORTADOS = new Set(["única", "multiple", "falso_verdadero", "autocompletar"]);

function canonTipo(t) {
  const s = String(t ?? "multiple")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (s === "unica") return "única";
  if (s === "multiple") return "multiple";
  if (s === "falso_verdadero" || s === "falso verdadero") return "falso_verdadero";
  if (s === "autocompletar") return "autocompletar";
  return t;
}

export function normalizarPreguntaApi(p) {
  const idPregunta = p?.idPregunta ?? p?.IdPregunta ?? p?.id ?? null;
  const tipoRaw = canonTipo(p?.Tipo ?? p?.tipo ?? "multiple");
  const opcionesRaw = Array.isArray(p?.Opciones ?? p?.opciones) ? p?.Opciones ?? p?.opciones : [];
  const opciones = opcionesRaw.map((o) => ({
    respuesta: o?.Respuesta ?? o?.respuesta ?? o?.Texto ?? "",
    correcta:
      o?.Correcta === true ||
      o?.correcta === true ||
      o?.EsCorrecta === true ||
      o?.Correcta === "1" ||
      o?.correcta === "1",
  }));
  let rango = Array.isArray(p?.Rango ?? p?.rango)
    ? [...(p?.Rango ?? p?.rango)]
    : [Number(p?.RangoMin ?? p?.rangoMin ?? 0), Number(p?.RangoMax ?? p?.rangoMax ?? 100)];
  rango = [Number(rango[0]) || 0, Number(rango[1]) || 100];
  const estado = Number(p?.Estado ?? p?.estado ?? 1);

  return {
    idPregunta,
    pregunta: p?.Pregunta ?? p?.pregunta ?? p?.Texto ?? "",
    descripcion: p?.Descripcion ?? p?.descripcion ?? "",
    tipo: tipoRaw,
    opciones,
    rango,
    estado,
  };
}

export function normalizarListaPreguntas(response) {
  const data = response?.data ?? response;
  const list = Array.isArray(data) ? data : data?.preguntas ?? data?.Preguntas ?? [];
  if (!Array.isArray(list)) return [];
  return list.map(normalizarPreguntaApi);
}

export function preguntaEsJugable(p) {
  if (!p || p.estado !== 1) return false;
  if (!TIPOS_SOPORTADOS.has(p.tipo)) return false;
  if (p.tipo === "autocompletar") {
    const blanks = (p.pregunta.match(/_____/g) || []).length;
    if (blanks === 0) return false;
    if (p.opciones.length !== blanks) return false;
    return p.opciones.every((o) => String(o.respuesta || "").trim());
  }
  return p.opciones.length >= 2;
}

export function filtrarPreguntasPorEdad(preguntas, edad) {
  if (edad == null || Number.isNaN(edad)) return preguntas;
  const [min, max] = [0, 100];
  return preguntas.filter((p) => {
    const [rMin, rMax] = p.rango;
    const lo = Number.isFinite(rMin) ? rMin : min;
    const hi = Number.isFinite(rMax) ? rMax : max;
    return edad >= lo && edad <= hi;
  });
}

export function seleccionarAleatorias(preguntas, n = 10) {
  const copy = [...preguntas];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, Math.min(n, copy.length));
}

export function indicesOpcionesCorrectas(pregunta) {
  const idx = [];
  pregunta.opciones.forEach((op, i) => {
    if (op.correcta) idx.push(i);
  });
  return idx;
}

function normalizarTexto(s) {
  return String(s || "")
    .trim()
    .toLocaleLowerCase("es");
}

export function evaluarRespuesta(pregunta, respuesta) {
  if (!preguntaEsJugable(pregunta)) return { ok: false, motivo: "no_jugable" };

  if (pregunta.tipo === "autocompletar") {
    const expected = pregunta.opciones.map((o) => normalizarTexto(o.respuesta));
    const got = Array.isArray(respuesta?.blanks) ? respuesta.blanks : [];
    if (got.length !== expected.length) return { ok: false };
    const ok = expected.every((exp, i) => normalizarTexto(got[i]) === exp);
    return { ok };
  }

  const selected = Array.isArray(respuesta?.indices) ? respuesta.indices.map(Number).sort((a, b) => a - b) : [];
  const correct = indicesOpcionesCorrectas(pregunta).sort((a, b) => a - b);
  if (pregunta.tipo === "única" || pregunta.tipo === "falso_verdadero") {
    if (selected.length !== 1) return { ok: false };
    return { ok: selected[0] === correct[0] };
  }
  if (pregunta.tipo === "multiple") {
    if (selected.length !== correct.length) return { ok: false };
    return { ok: selected.every((v, i) => v === correct[i]) };
  }
  return { ok: false };
}
